import { Button } from "@modernatx-internal/component-library";
import React from "react";

import type { FinderLocation } from "@/types/FinderLocation";

interface CallButtonProps {
  location: FinderLocation;
}

export const CallButton: React.FC<CallButtonProps> = ({ location }) => {
  if (!location.customer.phoneNumber) {
    return null;
  }

  return (
    <Button
      variant="outline"
      data-track="call-location"
      icon="phone"
      iconPosition="start"
      href={`tel:${location.customer.phoneNumber}`}
      sx={{ flexGrow: 0 }}
    >
      Call
    </Button>
  );
};
